import { useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import useApi from "@hooks/useApi"
import type {SinglePageConfig} from "@extension/config/pagesConfig";
import type { IContractTemplate } from "@interface/Interface";
import useUserRights from "@hooks/useUserRights";
import * as webSocket from "@tools/webSocket/webSocket";


interface Props {
    item: SinglePageConfig
    iconPath: string
    urlPath: string
    menuTextPath: string
    onClick : (data: string) => void
    onTitleClick : () => void
}

const useContractTemplates = (props: Props) : any => {
    const [contractTemplates, setContractTemplates ] = useState<any[]|null>(null);
    const { findPath } = useUserRights();
    const {onClick} = props;
    const [needToRefresh, setNeedToRefresh] = useState(false)
    const {api} = useApi({config: []});
    const loading = useRef(false)

    useEffect(() => {
        const ev = webSocket.on("message", async data => {
            const {type} = data || {}
            if(["create_contract_template", "update_contract_template", "remove_contract_template"].includes(type)) {
                setNeedToRefresh(old => !old)
            }
        })

        return () => {ev.off()}
    }, [])

    useEffect(() => {
        let mount = true
        if(!contractTemplates && !loading.current) {
            loading.current = true
            api.contractTemplate.searchContractTemplate({}).then(result => {
                if(!mount)
                    return

                const data = result.data as any;
                const templates = (data.data as IContractTemplate[]).sort((a: any, b: any) => (a.name || "") < (b.name || "") ? -1 : 1)
                loading.current = false
                setContractTemplates(templates?.map((item: IContractTemplate) => {
                    return {
                        key: item.id,
                        label: <Link to={`${findPath("contracts", "")}?type=${item.id}&label=${item.name}`}>{item.name}</Link>,
                        onTitleClick: () => {onClick(item?.id || "")}
                    }
                }))
            })
        }
        return () => {mount = false}
    }, [loading, needToRefresh])

    return {loading: loading.current, items: contractTemplates}
}
export default useContractTemplates;
